import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceVideoSettings } from '../../services/VideoService';
import { DeviceVideoSettings } from '../../types/Videos';

function useGetDeviceVideoSettings(deviceId: string | undefined, fleetId: string): UseQueryResult<DeviceVideoSettings> {
  return useQuery(
    ['device-video-settings', deviceId, fleetId],
    async (): Promise<DeviceVideoSettings> => getDeviceVideoSettings(deviceId, fleetId),
    {
      retry: 0,
      retryDelay: 1000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!fleetId && (deviceId !== undefined),
    },
  );
}

export default useGetDeviceVideoSettings;
